<ng-container *ngIf="label">
    <ng-container *ngIf="routerLink; else regularButton">
        <button
            mat-ripple
            class="ds-button"
            type="button"
            [disabled]="isDisabled"
            [ngClass]="buttonClasses"
            [queryParams]="queryParams"
            [routerLink]="routerLink"
            [routerLinkActive]="routerLink ? 'active' : null"
        >
            <ng-template [ngTemplateOutlet]="buttonContent"></ng-template>
        </button>
    </ng-container>

    <ng-template #regularButton>
        <button mat-ripple class="ds-button" [disabled]="isDisabled" [ngClass]="buttonClasses" (click)="buttonClick.emit()">
            <ng-template [ngTemplateOutlet]="buttonContent"></ng-template>
        </button>
    </ng-template>
</ng-container>

<ng-template #buttonContent>
    <ng-container *ngIf="icon">
        <mat-icon [fontSet]="iconFontSet">{{ icon }}</mat-icon>
    </ng-container>

    <span>{{ label }}</span>
</ng-template>
